import axios from 'axios'
import SessionStorage from "sessionstorage";
import {APIHOST} from "@/settings";

class SignService {
    getTimeStamp(signatureHex) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/SignTimestamp`, {
            params: {
                id: signatureHex
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    signInvoiceByExecutor(invoiceId, {
        fakturaPkcs7,
        roamingPkcs7,
        certificateSerial
    }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/SignInvoiceExecutor`, {
            FakturaPkcs7: fakturaPkcs7,
            RoamingPkcs7: roamingPkcs7,
            CertificateSerial: certificateSerial
        }, {
            params: {
                id: invoiceId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    signInvoiceByCustomer(invoiceId, {
        fakturaPkcs7,
        roamingPkcs7,
        certificateSerial
    }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/SignInvoiceCustomer`, {
            FakturaPkcs7: fakturaPkcs7,
            RoamingPkcs7: roamingPkcs7,
            CertificateSerial: certificateSerial
        }, {
            params: {
                id: invoiceId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getCancelHashCode(invoiceId) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/CancelInvoice`, {
            params: {
                id: invoiceId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    cancelInvoice(invoiceId, {
        fakturaPkcs7,
        roamingPkcs7,
        certificateSerial
    }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/CancelInvoice`, {
            FakturaPkcs7: fakturaPkcs7,
            RoamingPkcs7: roamingPkcs7,
            CertificateSerial: certificateSerial
        }, {
            params: {
                id: invoiceId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getFakturaHashCode(fakturaUniqueId) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/Sign`, {
            params: {
                id: fakturaUniqueId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    signKorzinkaRoamingDocument({fakturaUniqueId, fakturaPkcs7, roamingPkcs7, certificateSerial, actNumber}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/KorzinkaRoamingSign`, {
            FakturaPkcs7: fakturaPkcs7,
            RoamingPkcs7: roamingPkcs7,
            CertificateSerial: certificateSerial,
            ActNumber: actNumber
        }, {
            params: {
                id: fakturaUniqueId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getAttorneySignProperties(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/SignAttorneyProperties/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    signAttorney(attorneyId, {
        fakturaPkcs7,
        certificateSerial
    }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/SignAttorney`, {
            FakturaPkcs7: fakturaPkcs7,
            CertificateSerial: certificateSerial
        }, {
            params: {
                id: attorneyId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getReturnInvoiceSignProperties(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/SignReturnInvoiceProperties/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    signReturnInvoiceByExecutor(invoiceId, {
        fakturaPkcs7,
        roamingPkcs7,
        certificateSerial
    }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/SignReturnInvoiceExecutor`, {
            FakturaPkcs7: fakturaPkcs7,
            RoamingPkcs7: roamingPkcs7,
            CertificateSerial: certificateSerial
        }, {
            params: {
                id: invoiceId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    signReturnInvoiceByCustomer(invoiceId, {
        fakturaPkcs7,
        roamingPkcs7,
        certificateSerial
    }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/SignReturnInvoiceCustomer`, {
            FakturaPkcs7: fakturaPkcs7,
            RoamingPkcs7: roamingPkcs7,
            CertificateSerial: certificateSerial
        }, {
            params: {
                id: invoiceId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getRejectHashCode(documentUniqueId, comment) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/RoamingDecline`, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {
                id: documentUniqueId,
                comment: comment
            }
        });
    }

    rejectDocument(documentUniqueId, {
        fakturaPkcs7,
        roamingPkcs7,
        certificateSerial,
        comment
    }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/RoamingDecline`, {
            FakturaPkcs7: fakturaPkcs7,
            RoamingPkcs7: roamingPkcs7,
            CertificateSerial: certificateSerial,
            Comment: comment
        }, {
            params: {
                id: documentUniqueId
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }
}

export default new SignService()